import React from "react";

import Card from "react-bootstrap/Card";

import "./noPermissionsContainer.scss";

export default function NoPermissionsContainer({ styles }) {
  return (
    <div className="position-relative">
      <div
        className="max-width-wrapper overlay"
        data-testid="no-permission-backdrop"
      >
        <section>
          <Card body className="card--light">
            <div style={{ minHeight: 240 }} aria-hidden />
          </Card>
        </section>
      </div>
      <div
        className="permissions"
        data-testid="no-permissions-container"
        style={styles || {}}
      >
        <h1>You don't have permission to view this page </h1>
      </div>
    </div>
  );
}
